// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1G8du","colMin":"styles_colMin__2Raub","colCheckbox":"styles_colCheckbox__1PyNn"};